const apiUrl = process.env.REACT_APP_API_URL
export const logging = true

export default apiUrl